// React Query keys for the catalogue. Everything sits under ['catalog'] so one invalidation after a
// product change refreshes lists, details, pickers and categories together.
export const catalogKeys = {
  all: ['catalog'] as const,
  lists: ['catalog', 'list'] as const,
  list: (scope: string, params: Record<string, unknown>) => ['catalog', 'list', scope, params] as const,
  product: (shopId: string, id: string) => ['catalog', 'product', shopId, id] as const,
  audit: (shopId: string, id: string) => ['catalog', 'audit', shopId, id] as const,
  categories: (line: string) => ['catalog', 'categories', line] as const,
  opsCategories: ['catalog', 'ops-categories'] as const,
  picker: (shopId: string, q: string) => ['catalog', 'picker', shopId, q] as const,
};
